/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminTerminalPaymentChargeRequest,
  AdminTerminalPaymentChargeResponse,
  AdminTerminalPaymentFeeRequest,
  AdminTerminalPaymentFeeResponse,
  AdminTerminalPaymentRecentTitles
} from '.././model';

import adminV1OrganizationsPaymentsTerminalCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsTerminalRefundCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsTerminalFeeCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsTerminalTitlesRetrieveMutator from '../../shared/services/axios-client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Virtual terminal: charge a payer's saved card or ACH from the Payments Log.
 * @summary Charge a terminal payment
 */
export const adminV1OrganizationsPaymentsTerminalCreate = (
    organizationId: number,
    adminTerminalPaymentChargeRequest: AdminTerminalPaymentChargeRequest,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsTerminalCreateMutator<AdminTerminalPaymentChargeResponse>>,) => {
      return adminV1OrganizationsPaymentsTerminalCreateMutator<AdminTerminalPaymentChargeResponse>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/terminal/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminTerminalPaymentChargeRequest
    },
      options);
    }
  /**
 * Virtual terminal: charge a payer's saved card or ACH from the Payments Log.
 * @summary Refund a terminal payment (amount only, fee kept)
 */
export const adminV1OrganizationsPaymentsTerminalRefundCreate = (
    organizationId: number,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsTerminalRefundCreateMutator<void>>,) => {
      return adminV1OrganizationsPaymentsTerminalRefundCreateMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/terminal/${id}/refund/`, method: 'POST'
    },
      options);
    }
  /**
 * Virtual terminal: charge a payer's saved card or ACH from the Payments Log.
 * @summary Preview the fee and total for a terminal payment
 */
export const adminV1OrganizationsPaymentsTerminalFeeCreate = (
    organizationId: number,
    adminTerminalPaymentFeeRequest: AdminTerminalPaymentFeeRequest,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsTerminalFeeCreateMutator<AdminTerminalPaymentFeeResponse>>,) => {
      return adminV1OrganizationsPaymentsTerminalFeeCreateMutator<AdminTerminalPaymentFeeResponse>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/terminal/fee/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminTerminalPaymentFeeRequest
    },
      options);
    }
  /**
 * Virtual terminal: charge a payer's saved card or ACH from the Payments Log.
 * @summary Recent titles used on this organization's terminal payments, newest first
 */
export const adminV1OrganizationsPaymentsTerminalTitlesRetrieve = (
    organizationId: number,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsTerminalTitlesRetrieveMutator<AdminTerminalPaymentRecentTitles>>,) => {
      return adminV1OrganizationsPaymentsTerminalTitlesRetrieveMutator<AdminTerminalPaymentRecentTitles>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/terminal/titles/`, method: 'GET'
    },
      options);
    }
  export type AdminV1OrganizationsPaymentsTerminalCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsTerminalCreate>>>
export type AdminV1OrganizationsPaymentsTerminalRefundCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsTerminalRefundCreate>>>
export type AdminV1OrganizationsPaymentsTerminalFeeCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsTerminalFeeCreate>>>
export type AdminV1OrganizationsPaymentsTerminalTitlesRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsTerminalTitlesRetrieve>>>
